import React, { useEffect, useState } from 'react';
import { getUploadedImagePath, useAppDispatch, useAppState } from '@nutastic/nutastic-react-app';
import { useParams } from 'react-router-dom';
import { WebsiteActions } from '../../state/actions.mjs';
import classnames from 'classnames';
import { useNavigation } from '../../hooks/useNavigation';
import ContentNotFoundPage from './ContentNotFoundPage';

const componentClass = 'listPage';

const SeriesPage = () => {
    const appDispatch = useAppDispatch();
    const { isProcessing, content: { videoSeries } } = useAppState();
    const { loadPage } = useNavigation();
    const [ selectedSeries, setSelectedSeries ] = useState(null);
    const [ hasFetched, setHasFetched ] = useState(false);
    const { id: slugParam } = useParams();
    const {
        title: pageTitle,
        field_1: subtitle,
        content: description,
        image,
        videoSet
    } = selectedSeries || {};

    //mimicking a load effect for the heck of it :-)
    useEffect(() => {
        setHasFetched(false);
        appDispatch({ type: WebsiteActions.LOADING_PAGE_START });
        setSelectedSeries(null);
        const matchedSeries = (videoSeries || []).find(s => s?.slug === slugParam);
        setSelectedSeries(matchedSeries);
        setTimeout(() => {
            setHasFetched(true);
            appDispatch({ type: WebsiteActions.LOADING_PAGE_DONE });
        }, 1000);
    }, []);

    const renderSeriesVideos = () => {
        const classes = classnames(`${componentClass}__item`, 'useWideImage');
        return (videoSet || []).map(c => {
            const {image, slug, title} = c;
            return <div className={classes} onClick={() => loadPage(`/content/video/${slug}`)}>
                <img src={getUploadedImagePath(image)} alt={`${title} | NuStation`} />
                <div>
                    <p>{ title }</p>
                    <p className="d-none">{ slug }</p>
                </div>
            </div>
        });
    };

    return (!isProcessing && selectedSeries) ? <article className={componentClass}>
        <div className={`${componentClass}__header`}>
            <h1>{ pageTitle }</h1>
        </div>
        <div className={`${componentClass}__content`}>
            <div className={`${componentClass}__section`}>
                <h2>{ subtitle }</h2>
                <p>{ description }</p>
            </div>
            <div className={`${componentClass}__list`}>
                { renderSeriesVideos() }
            </div>
        </div>
    </article> : <ContentNotFoundPage isProcessing={isProcessing || !hasFetched} />;
};

export default SeriesPage;
